import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getSchoolClassesConfig,
  getSchoolConfig
} from '../../../apis/schoolConfig';
import {
  SchoolClassesConfig,
  SchoolConfig
} from '../../../types/schoolConfigType';
import { RequestStatus } from '../../../enums';

interface SchoolConfigState {
  schoolConfig: SchoolConfig | null;
  schoolClassesConfig: SchoolClassesConfig | null;
  loadingStatus?: RequestStatus;
}

const initialState: SchoolConfigState = {
  schoolConfig: null,
  schoolClassesConfig: null,
  loadingStatus: undefined
};

const fetchSchoolConfig = createAsyncThunk(
  'school/fetch-config',
  async (school: string, { rejectWithValue }) => {
    try {
      const schoolConfig = await getSchoolConfig(school);
      return schoolConfig;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const fetchSchoolClassesConfig = createAsyncThunk(
  'school/fetch-classes-config',
  async (school: string, { rejectWithValue }) => {
    try {
      const schoolConfig = await getSchoolClassesConfig(school);
      return schoolConfig;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const schoolConfigSlice = createSlice({
  name: 'schoolConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolConfig.pending, (state) => {
        state.loadingStatus = RequestStatus.LOADING;
      })
      .addCase(fetchSchoolConfig.fulfilled, (state, action) => {
        state.schoolConfig = action.payload as any;
        state.loadingStatus = RequestStatus.SUCCESS;
      })
      .addCase(fetchSchoolConfig.rejected, (state) => {
        state.loadingStatus = RequestStatus.FAILED;
      })
      .addCase(fetchSchoolClassesConfig.fulfilled, (state, action) => {
        state.schoolClassesConfig = action.payload.data;
      })
      .addCase(fetchSchoolClassesConfig.rejected, (state) => {
        // Optionally handle rejected state here
      });
  }
});

export { fetchSchoolConfig, fetchSchoolClassesConfig };
export default schoolConfigSlice;
